module.exports = __webpack_public_path__ + "img/icon_instagram_crop.87b648a8.svg";